export enum ThemeVariants {
  Light = 'light',
  Dark = 'dark',
}

export const APP_HEADER_HEIGHT = 80;
export const NAVIGATION_ICON_CONTAINER_WIDTH = 3.5;
export const NAVIGATION_BAR_WIDTH = 16.5;
export const NAVIGATION_BAR_LAPTOP_WIDTH = 1450;
